import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { Pencil, Check } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useEditMode } from '../context/EditModeContext';
import './editmode.css';

const EditLayer = lazy(() => import('./EditLayer'));

// Routes where on-site editing makes no sense (admin/checkout/auth surfaces).
const HIDDEN = ['/admin', '/pos', '/barcode-sheet', '/login', '/register', '/checkout', '/reset-password', '/forgot-password'];

export default function EditToggle() {
  const { user } = useAuth();
  const { editMode, setEditMode } = useEditMode();
  const location = useLocation();

  if (!user || user.role !== 'admin') return null;
  if (HIDDEN.some(p => location.pathname.startsWith(p))) return null;

  return (
    <>
      <button
        onClick={() => setEditMode(e => !e)}
        className={`cms-edit-fab ${editMode ? 'on' : ''}`}
        data-testid="edit-page-toggle">
        {editMode ? <><Check size={15} /> Done Editing</> : <><Pencil size={15} /> Edit Page</>}
      </button>
      {editMode && <Suspense fallback={null}><EditLayer /></Suspense>}
    </>
  );
}
